import { Observable } from 'rxjs/Observable';
import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';


// Denne class lagrer alle glosene til brukeren
// alle componentsene kan se her

@Injectable()
export class MyListService {

  myFokos: Observable<any[]>;

  databaseLocation: AngularFireList<{}>;

  dataIsLoaded = false;

  uid: String;

  constructor(auth: AuthService, public database: AngularFireDatabase) {


    this.myFokos = auth.user$.switchMap(user => {
      if (user) {
        this.databaseLocation = database.list('users/' + user.uid + '/glossaries');
        this.uid = user.uid;
        return this.databaseLocation.snapshotChanges();
      }
    });

    this.myFokos.take(1).subscribe(() => this.dataIsLoaded = true); // TODO: unsubscribe
  }

  shareFoko(key: String) {

  }

  editFoko(key: String) {

  }

  deleteFoko(key: String) {
    this.database.object('users/' + this.uid + "/glossaries/" + key).remove();
  }

}



// WEBPACK FOOTER //
// /Users/magnustrandokken/Desktop/Magson/Web/Foko/foko-angular/src/app/services/my-list.service.ts